export default __webpack_public_path__ + "static/sprite-f13bebee30859bef9364d96512daaa68.svg";